import React, { useEffect, useState } from "react";
import "./Billing.css";
import apiCall from "../utils/api";
import Loader from "../components/Loader";

const Billing = () => {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // Get the current month and year
  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-based month
    const currentYear = currentDate.getFullYear();

    // Set the default values for month and year
    setSelectedMonth(currentMonth + 1); // +1 because months are 0-based
    setSelectedYear(currentYear);
  }, []);

  useEffect(() => {
    if (selectedMonth && selectedYear && isInitialLoad) {
      setIsInitialLoad(false);
      handleGetEarnings();
    }
  }, [selectedMonth, selectedYear]);

  // Generate month and year options dynamically
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = [];
  for (let i = 2020; i <= 2040; i++) {
    years.push(i);
  }

  // Handle the change in month and year
  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const getSelectedDate = () => {
    const monthFormatted =
      selectedMonth < 10 ? `0${selectedMonth}` : selectedMonth;
    const startDate = `${selectedYear}-${monthFormatted}-01`; // Default to 1st day of the month

    // Get the last date of the selected month
    const lastDayOfMonth = new Date(selectedYear, selectedMonth, 0); // 0 gives us the last day of the previous month
    const endDate = lastDayOfMonth.getDate(); // Get the actual date (last day of the month)

    // Return both start and end dates
    return {
      startDate: startDate,
      endDate: `${selectedYear}-${monthFormatted}-${
        endDate < 10 ? `0${endDate}` : endDate
      }`,
    };
  };

  const handleGetEarnings = async () => {
    setLoading(true); // Set loading state to true when the request starts
    const selectedDate = getSelectedDate(); // Get the selected date from your function
  
    await apiCall({
      url: `https://supplier.innovatemr.net/api/v2/supply/getSurveyStatsByDateRange?Verified Start Date=${selectedDate?.startDate}&Verified End Date=${selectedDate?.endDate}&startDate=${selectedDate?.startDate}&endDate=${selectedDate?.endDate}`,
      method: "GET",
    })
      .then((response) => {
        if (response.status === 200) {
          setData(response);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
          console.error(`Error: ${response.status} - ${response.statusText}`);
        }
      })
      .catch((error) => {
        console.error("Error occurred during the API call:", error);
      })
      .finally(() => {
        setLoading(false); // Set loading state to false after the request is complete
      });
  };
  

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="monthDropdown" className="font-weight-bold">
              Select Month:
            </label>
            <select
              id="monthDropdown"
              className="form-control"
              value={selectedMonth}
              onChange={handleMonthChange}
            >
              {months.map((month, index) => (
                <option key={index} value={index + 1}>
                  {month}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="yearDropdown" className="font-weight-bold">
              Select Year:
            </label>
            <select
              id="yearDropdown"
              className="form-control"
              value={selectedYear}
              onChange={handleYearChange}
            >
              {years.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-primary"
          style={{
            backgroundColor: "#ff7503",
            borderColor: "#ff7503",
            color: "white",
          }}
          onClick={() => handleGetEarnings()}
        >
          Get Earnings
        </button>
      </div>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card shadow-lg">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#ff7503" }}
              >
                <h4 className="mb-0">
                  {months[selectedMonth - 1] + " - " + selectedYear}
                </h4>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <strong>Clicks:</strong>{" "}
                      <span>{data?.result?.clicks}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Survey Starts:</strong>{" "}
                      <span>{data?.result?.surveyStarts}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Completes:</strong>{" "}
                      <span>{data?.result?.completes}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Fails:</strong> <span>{data?.result?.fails}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Over Quota:</strong>{" "}
                      <span>{data?.result?.overQuota}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Quality Terms:</strong>{" "}
                      <span>{data?.result?.qualityTerms}</span>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <strong>Pre-Survey Terminates:</strong>{" "}
                      <span>{data?.result?.preSurveyTerminates}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Pre-Survey Over Quota:</strong>{" "}
                      <span>{data?.result?.preSurveyOverQuota}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Pre-Survey Quality Termination:</strong>{" "}
                      <span>{data?.result?.preSurveyQualityTermination}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Average LOI:</strong>{" "}
                      <span>{data?.result?.averageLOI} minutes</span>
                    </div>
                    <div className="mb-3">
                      <strong>Revenue:</strong>{" "}
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        ${data?.result?.revenue}
                      </span>
                    </div>
                    <div className="mb-3">
                      <strong>Conversion Rate:</strong>{" "}
                      <span>{data?.result?.Conversion}%</span>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <strong>Valid Completes:</strong>{" "}
                      <span style={{ color: "green", fontWeight: "bold" }}>
                        {data?.result?.validCompletes}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <strong>Invalid Completes:</strong>{" "}
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        {data?.result?.invalidCompletes}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <strong>Pending Completes:</strong>{" "}
                      <span style={{ color: "blue", fontWeight: "bold" }}>
                        {data?.result?.pendingCompletes}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Billing;
